if (!window.Eurus) window.Eurus = { loadedScript: new Set() };
if (!window.Eurus.loadedScript.has("skin-diagnosis.js")) {
  window.Eurus.loadedScript.add("skin-diagnosis.js");

  const RESULT_TYPES = new Set([
    "dry",
    "normal",
    "sensitive",
    "combination",
    "aging",
  ]);

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xSkinDiagnosis", (sectionId) => ({
        started: false,
        modalOpen: false,
        currentQuestionId: null,
        resultType: null,
        firstQuestionId: null,
        questionMap: {},
        answeredCount: 0,
        maxSteps: 6,

        init() {
          const questions = this.$el.querySelectorAll(".skin-diagnosis-question");
          questions.forEach((q, i) => {
            const id = q.dataset.questionId;
            if (!id) {
              console.warn(
                `[skin-diagnosis:${sectionId}] 質問IDが未設定のブロックがあります。テーマエディタで質問IDを入力してください。`
              );
              return;
            }
            if (this.questionMap[id]) {
              console.warn(
                `[skin-diagnosis:${sectionId}] 質問ID "${id}" が重複しています。片方の質問が表示されません。`
              );
            }
            if (i === 0) this.firstQuestionId = id;
            this.questionMap[id] = {
              yes: q.dataset.yesTarget,
              no: q.dataset.noTarget,
            };
          });

          Object.entries(this.questionMap).forEach(([id, node]) => {
            [
              ["yes", node.yes],
              ["no", node.no],
            ].forEach(([label, target]) => {
              if (!target) {
                console.warn(
                  `[skin-diagnosis:${sectionId}] 質問 "${id}" の${label}遷移先が未設定です。`
                );
              } else if (!this.questionMap[target] && !RESULT_TYPES.has(target)) {
                console.warn(
                  `[skin-diagnosis:${sectionId}] 質問 "${id}" の${label}遷移先 "${target}" は存在しない質問IDでも結果タイプでもありません。診断が正しく完了しない可能性があります。`
                );
              }
            });
          });
        },

        _track(eventName, params) {
          if (typeof window.gtag === "function") {
            window.gtag("event", eventName, params || {});
          }
        },

        start() {
          this.started = true;
          this.modalOpen = true;
          this.resultType = null;
          this.answeredCount = 0;
          this.currentQuestionId = this.firstQuestionId;
          this._track("skin_diagnosis_start", { section_id: sectionId });
          this._lockScroll();
        },

        answer(value) {
          const node = this.questionMap[this.currentQuestionId];
          if (!node) return;
          const target = value ? node.yes : node.no;

          this._track("skin_diagnosis_answer", {
            section_id: sectionId,
            question_id: this.currentQuestionId,
            answer: value ? "yes" : "no",
          });

          this.answeredCount += 1;

          if (this.questionMap[target]) {
            this.currentQuestionId = target;
          } else {
            this.resultType = RESULT_TYPES.has(target) ? target : "unknown";
            this.currentQuestionId = null;
            this._track("skin_diagnosis_result", {
              section_id: sectionId,
              result_type: this.resultType,
            });
          }
        },

        reset() {
          this.started = false;
          this.modalOpen = false;
          this.currentQuestionId = null;
          this.resultType = null;
          this.answeredCount = 0;
          this._unlockScroll();
        },

        _lockScroll() {
          document.documentElement.style.overflow = "hidden";
        },

        _unlockScroll() {
          document.documentElement.style.overflow = "";
        },
      }));
    });
  });
}
